module.exports = __webpack_public_path__ + "static/img/autumn_pingguoPic.b5b17567.png";